export const linesAmount = 10;
export const randomColorsText = '💡';
export const completeLineText = '🎲';
